module.exports = __webpack_public_path__ + "static/media/logo-saintpaulwhite.dd7aafca.png";